import React from 'react';
import BillingComponent from '@/features/subscription/components/Billing';
import HerokuBilling from '@/components/billing/HerokuBilling';
import { useSelector } from 'react-redux';

const Billing = () => {
  const isHeroku = useSelector((s: any) => s.datasource.isHerokuBeta);
  const isBilledByPanoply = useSelector(
    (s: any) => s.datasource.isBilledByPanoply,
  );

  return isHeroku || isBilledByPanoply ? (
    <HerokuBilling isPanoply={isBilledByPanoply} />
  ) : (
    <BillingComponent />
  );
};

export default Billing;
